import { useMessageThreadInfo } from "../../hooks/useMessageThreadInfo";
import { Redo } from "lucide-react";
import "./HumanMessage.css";
import { HumanMessage as HumanMessageType } from "./types";
import { useDispatch } from "react-redux";
import {
  setCurrentThread,
  setPrompt,
} from "../../redux/features/agent/agentSlice";
import { ThreadInfo } from "./ThreadInfo";
import { MessageHistoryType } from "winslow-core";

type HumanMessageProps = {
  message: HumanMessageType;
  handleStartNewThread: (
    personaId: string | null,
    employeeId: string | null
  ) => void;
};

export const HumanMessage = ({
  message,
  handleStartNewThread,
}: HumanMessageProps) => {
  const contextInfo = useMessageThreadInfo(message.messageThread);

  const dispatch = useDispatch();

  return (
    <div className=" agent-chat-human-message">
      <div className="agent-chat-history-item-prompt-container">
        <div className="agent-chat-history-item-prompt-hover-icon">
          <Redo
            size={16}
            onClick={() => {
              console.log(
                "message.message.kwargs.content",
                message.message.kwargs.content
              );
              dispatch(setPrompt(message.message.kwargs.content));
              const thread = message?.messageThread;
              handleStartNewThread(
                thread?.personaId || null,
                thread?.employeeId || null
              );
            }}
          />
        </div>
        <div
          id={"human_message_" + message.id.toString()}
          className="agent-chat-history-item-prompt">
          {message.message.kwargs.content}
        </div>
      </div>
      {contextInfo && (
        <ThreadInfo avatar={contextInfo.avatar} label={contextInfo.label} />
      )}
    </div>
  );
};
